/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promos_Empty_StateInputs */



/**
* | output |
* | --- |
* | "No promo cards recorded. Add the promos handed out at this event." |
*
* @param {Promos_Empty_StateInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promos_empty_state = /** @type {((inputs?: Promos_Empty_StateInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promos_Empty_StateInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune carte promo enregistrée. Ajoutez les promos distribuées lors de cet événement.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay cartas promo registradas. Añada las promos distribuidas en este evento.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhuma carta promo registrada. Adicione as promos distribuídas neste evento.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna carta promo registrata. Aggiungi le promo distribuite a questo evento.")
	return /** @type {LocalizedString} */ ("No promo cards recorded. Add the promos handed out at this event.")
});